import {
  RESOURCES_LIST_REQUEST,
  RESOURCES_LIST_SUCCESS,
  RESOURCES_LIST_FAILURE,
  RESOURCES_ADD_SUCCESS,
  RESOURCES_UPDATE_SUCCESS,
} from '@/constants/ActionsType';
// import { message } from 'antd';
import message from "antd/lib/message";

const initState = {
  list: [],
  total: 0,
  loading: false,
};

function resourcesReducer(state = initState, action) {
  switch (action.type) {
    case RESOURCES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RESOURCES_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.list,
        loading: false,
        total: action.payload.total,
      };
    case RESOURCES_LIST_FAILURE:
      message.error(action.payload);
      return {
        ...state,
        loading: false,
      };
    // case RESOURCES_REMOVE_SUCCESS:
    //   return {
    //     ...state,
    //     list: state.list.filter(item => item.id !== action.payload.id),
    //     total: state.total - 1
    //   };
    case RESOURCES_ADD_SUCCESS:
      return {
        ...state,
        list: state.list.concat(action.payload),
      };
    case RESOURCES_UPDATE_SUCCESS:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.id === action.payload.id) {
            Object.keys(action.payload).forEach((key) => {
              item[key] = action.payload[key];
            });
            return item;
          }
          return item;
        }),
      };
    default:
      return state;
  }
}

export default resourcesReducer;
